export const SettingType = {
  SERVICE_MAINTENANCE_REQUEST: "SERVICE_MAINTENANCE_REQUEST",
  SERVICE_MAINTENANCE_SUCCESS: "SERVICE_MAINTENANCE_SUCCESS",
  SERVICE_MAINTENANCE_FAIL: "SERVICE_MAINTENANCE_FAIL",
  KIOSK_RESTART_REQUEST: "KIOSK_RESTART_REQUEST",
  KIOSK_RESTART_SUCCESS: "KIOSK_RESTART_SUCCESS",
  KIOSK_RESTART_FAIL: "KIOSK_RESTART_FAIL",
  CHANGE_WINNING_RATIO_REQUEST: "CHANGE_WINNING_RATIO_REQUEST",
  CHANGE_WINNING_RATIO_SUCCESS: "CHANGE_WINNING_RATIO_SUCCESS",
  CHANGE_WINNING_RATIO_FAIL: "CHANGE_WINNING_RATIO_FAIL"
};
